import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const [showImage, setShowImage] = useState(false);
  const location = useLocation(); // React Router's useLocation hook

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const closeMenu = () => {
    setMenuOpen(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 10) {
        setShowImage(true);
      } else {
        setShowImage(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Reset menu state on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);
  
  return (
    <>
    <nav  className={showImage? "navbar active" : "navbar "}>
      <div className="navbar-container">
      <Link to="/" className='navbar-logo'>
          <img src='https://res.cloudinary.com/diqtww8g5/image/upload/v1707067339/Untitled_design_72_uresqo.png' alt='logo' />
        </Link>
        <div className={`menu-icon ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
      {menuOpen ? <FaTimes /> : <FaBars />}
    </div>
        <ul ref={menuRef} className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>
              Home
            </Link>
          </li>
       

        
<li className="nav-item">
            <Link to="/Create-campaign" className="nav-link" onClick={() => setMenuOpen(false)}>
          Create Campaign
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/chat" className="nav-link" onClick={() => setMenuOpen(false)}>
          about us
            </Link>
          </li>
          
            
            <li className="nav-item">
            <Link to="/contact-us" className="nav-link" onClick={() => setMenuOpen(false)}>
              Contact us
            </Link> </li>

            
        </ul>
      </div>
    </nav>
</>
  );
};

export default Navbar